import React from 'react';
import { testId } from '../../../../utils/testIds';

function CheckboxField({ config, value, onChange, onBlur, disabled }) {
  const inlineLabel = config?.fieldSettings?.inlineLabel ?? '';
  const id = config?.fieldKey;
  return (
    <span className={`field-engine-checkbox${disabled ? ' disabled' : ''}`}>
      <input
        id={id}
        data-test={testId('field', config?.fieldKey, 'input')}
        type="checkbox"
        checked={!!value}
        onChange={e => onChange(e.target.checked)}
        onBlur={onBlur}
        disabled={disabled}
      />
      <label htmlFor={id}>{inlineLabel}</label>
    </span>
  );
}

export default CheckboxField;
